import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { PartnerRouteParams } from './core/routeparams';

@Injectable({ providedIn: 'root' })
export class SelectedPartnerService {
  private selectedPartnerId$$ = new ReplaySubject<string>(1);

  resolve(route: ActivatedRouteSnapshot): string | null {
    const partnerId = (route.params as PartnerRouteParams).partnerId;
    if (partnerId) {
      this.selectedPartnerId$$.next(partnerId);
      return partnerId;
    }
    return null;
  }

  public getPartnerId(): Observable<string> {
    return this.selectedPartnerId$$.pipe(distinctUntilChanged(), shareReplay());
  }
}
